import { onConfig } from "@/config";

export let DATA_OVERVIEW_ENDPOINT = "";

onConfig((config) => {
  DATA_OVERVIEW_ENDPOINT = config.VUE_APP_BASIC_URL + "/ws/dataoverview";
});

export const EMPTY_DATA_OVERVIEW_LIST = [];
